import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy } from "lucide-react";

let cache = null;
let pending = null;

const loadWinner = () => {
  if (!pending) {
    pending = api.get("/dashboard/last-winner").then(({ data }) => { cache = data; return data; }).catch(() => { pending = null; return null; });
  }
  return pending;
};

export const WinnerTrophy = ({ userId }) => {
  const [w, setW] = useState(cache);
  useEffect(() => {
    if (!cache) { loadWinner().then((d) => { if (d) { setW(d); } }); }
  }, []);
  if (!w?.user_id || !userId || w.user_id !== userId) { return null; }
  return (
    <span
      title={`Agent of the Month - ${w.label}`}
      data-testid={`winner-trophy-${userId}`}
      className="inline-flex items-center gap-0.5 shrink-0 px-1 h-4 rounded-sm bg-red-600 text-white text-[9px] font-mono uppercase tracking-wider align-middle"
    >
      <Trophy className="h-2.5 w-2.5" strokeWidth={2.25} />
    </span>
  );
};
